import styled, { css } from 'styled-components';
import { rem } from 'polished';

import { Row } from '../../base/Grid';

export const SwiperCarouselContainerRow = styled(Row)`
&& {
  width: 100%;
  height: 100%;
  padding-bottom: ${rem('40px')};
}
`

export const SwiperCarouselSwiperSlide = styled.div`
  display: flex;
  justify-content: center;
`

export const SwiperCarouselSwiperSlideRow = styled(Row)`
  width: 100%;
  justify-content: center;
`

export const SwiperCarouselSwiperPagination = styled.div`
  && {
    width: 100%;
    bottom: 0;
  }
`

export const SwiperCarouselSwiperNavigation = styled.div`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    return css`
      && {
        height: ${smallUp ? 'unset' : '100%'};
        top: ${smallUp ? '45%' : rem('0px')};
        background-color: ${smallUp ? 'unset' : 'rgba(255,255,255,0.3)'};
        &::after {
          color: ${theme.colors.neutral.grey41};
        }
      }
    `
  }}
`
